const themeControllerInputs = document.querySelectorAll<HTMLInputElement>('.theme-controller');

themeControllerInputs.forEach((input) => {
  input.addEventListener('change', () => {
    if (input.checked) {
      localStorage.setItem('theme', 'ezdark');
      document.documentElement.setAttribute('data-theme', 'ezdark');
    } else {
      localStorage.setItem('theme', 'ezligth');
      document.documentElement.setAttribute('data-theme', 'ezligth');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const theme = localStorage.getItem('theme');
  if (theme === 'ezdark') {
    document.documentElement.setAttribute('data-theme', 'ezdark');
    themeControllerInputs.forEach((input) => {
      input.checked = true;
    });
  }
});
